<template>
  <div class="loading">
    <div class="loader">
      <svg
        viewBox="0 0 46 46"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        :stroke="color"
      >
        <g
          fill="none"
          fill-rule="evenodd"
        >
          <g
            transform="translate(2 2)"
            stroke-width="4"
          >
            <circle
              stroke-opacity=".25"
              cx="21"
              cy="21"
              r="18"
            />
            <path d="M21 3c-9.94 0-18 8.06-18 18">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 21 21"
                to="360 21 21"
                dur="0.8s"
                repeatCount="indefinite"
              />
            </path>
          </g>
        </g>
      </svg>
      <div
        v-if="text"
        :style="{ color }"
        class="loading-text"
      >
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LoadingStateComponent',
  props: {
    color: {
      type: String,
      default: '#000',
    },
    height: {
      type: Number,
      default: 72,
    },
    width: {
      type: Number,
      default: 72,
    },
    text: {
      type: String,
      default: '',
    },
  },
});
</script>

<style>
.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.loader {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.loading-text {
  margin-top: 16px;
  font-size: 20px;
}
</style>
